module.exports = __webpack_public_path__ + "static/media/drag.466f8edb.svg";